<template>
  <div style="background-color: white;padding: 20px;margin-top: -16px;border: 1px solid #dee2e6;border-top: none">

    <div class="row dash-chart">
      <div class="col-xl-4 box-col-4 col-lg-12 col-md-4">
        <div class="card o-hidden">
          <div class="card-body">
            <div class="ecommerce-widgets media">
              <div class="ecommerce-box light-bg-primary mr-4">
                <i class="fa fa-sort-amount-asc" aria-hidden="true"></i>
              </div>
              <div class="media-body">
                <p class="f-w-500 font-roboto">
                  {{ $t('message.budget_related_net') }}
                </p>
                <h4 class="f-w-500 mb-0 f-20">
                  {{ profit_margin != '-' && !isNaN(profit_margin) ? profit_margin + '%' : '-' }}
                </h4>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-4 box-col-4 col-lg-12 col-md-4">
        <div class="card o-hidden">
          <div class="card-body">
            <div class="ecommerce-widgets media">
              <div class="ecommerce-box light-bg-primary mr-4">
                <i class="fa fa-fire" aria-hidden="true"></i>
              </div>
              <div class="media-body">
                <p class="f-w-500 font-roboto">
                  {{ $t('message.budget_performance') }}:
                </p>
                <h4 class="f-w-500 mb-0 f-20">
                  <span style="color: #e20909" v-if="performance < 2">{{ $t('message.budget_poor') }}</span>
                  <span style="color: #ffbf00" v-if="performance == 2">{{ $t('message.budget_good') }}</span>
                  <span style="color: #00ad2e" v-if="performance == 3">{{ $t('message.budget_excellent') }}</span>
                </h4>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-4 box-col-4 col-lg-12 col-md-4">
        <div class="card o-hidden">
          <div class="card-body">
            <div class="ecommerce-widgets media">
              <div class="ecommerce-box light-bg-primary mr-4">
                <i class="fa fa-tasks" aria-hidden="true"></i>
              </div>
              <div class="media-body">
                <p class="f-w-500 font-roboto">
                  {{ $t('message.budget_break_even') }}
                </p>
                <h4 class="f-w-500 mb-0 f-20">
                  {{ break_even }}
                </h4>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="steps && steps.length" class="mb-4">
      <h6>{{ $t('message.budget_related_steps') }}</h6>
      <button type="button" class="btn btn-sm btn-primary mr-1 mb-2"
              v-for="step in steps" :key="step.id">
        {{ step.translation['en'].name }}
      </button>
    </div>

    <apexchart
        :key="apexChartKey"
        height="550"
        type="line"
        :options="chartOptions"
        :series="series"
    ></apexchart>

  </div>
</template>
<script>

export default {
  name: "BudgetSummary",
  props: {
    budget: {
      default: function () {
        return {}
      },
      type: Object
    },
    steps: {
      default: function () {
        return []
      },
      type: Array
    },
    token: {
      default: '',
      type: null
    }
  },
  components: {},
  data() {
    return {
      break_even: '-',
      profit_margin: '-',
      anualFlag: 0,
      totalFlag: 0,
      cashFlag: 0,
      dataSum: {
        expenses: [],
        revenue: [],
        capital: []
      },
      series: [],
      apexChartKey: Math.random(),
      chartOptions: {

        chart: {
          stacked: false,
          type: 'line',
          height: 350,
          animations: {
            enabled: false
          }
        },
        annotations: {
          xaxis: [{
            x: null,
            strokeDashArray: 3,
            borderColor: '#ff00b5',
            label: {
              borderColor: '#ff00b5',
              style: {
                color: '#ffffff',
                background: '#ff00b5',
              },
              text: 'Break even'
            }
          }]
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded'
          },
        },
        dataLabels: {
          style: {
            fontSize: '12px',
            fontWeight: 'bold',
          },

          enabled: true,
          enabledOnSeries: [2, 3]
        },
        stroke: {
          show: true,
          width: 4,
          curve: 'smooth'
        },
        xaxis: {
          categories: [],
          labels: {
            rotate: -45,
            rotateAlways: true,
            offsetY: 5,
            formatter: (value) => {

              let label = value
              if (value) {
                label = this.moment(value).locale(this.locale).format('MMM, YY')
              }

              return label;
            }
          }
        },
        yaxis: {
          title: {
            text: this.$t('message.budget_amount')
          },
        },
        fill: {
          opacity: 1
        },
      },
    }
  },
  async created() {

    this.chartOptions.xaxis.categories = this.buildMonthsPeriod()
    this.original_labels = [...this.chartOptions.xaxis.categories]

    let categories = this.budget.categories

    let expenses = categories.find((item) => {
      return item.name == "Expenses"
    })

    let revenue = categories.find((item) => {
      return item.name == "Revenue"
    })

    let capital = categories.find((item) => {
      return item.name == "Capital"
    })


    this.dataSum['expenses'] = Array(this.chartOptions.xaxis.categories.length).fill(0);
    this.dataSum['revenue'] = Array(this.chartOptions.xaxis.categories.length).fill(0);
    this.dataSum['capital'] = Array(this.chartOptions.xaxis.categories.length).fill(0);

    let expensesRes = await this.loadSection(expenses.id)
    expensesRes.chart.data = this.rebuildData(expensesRes, this.original_labels.length)

    this.setArrays(expensesRes, 'expenses', this.original_labels[1].length)

    let revenueRes = await this.loadSection(revenue.id)

    revenueRes.chart.data = this.rebuildData(revenueRes, this.original_labels.length)

    this.setArrays(revenueRes, 'revenue', this.original_labels[1].length)

    let capitalRes = await this.loadSection(capital.id)

    capitalRes.chart.data = this.rebuildData(capitalRes, this.original_labels.length)

    this.setArrays(capitalRes, 'capital', this.original_labels[1].length)

    let cashBalance = Array(this.chartOptions.xaxis.categories.length).fill(0);
    let monthlyAnnual = Array(this.chartOptions.xaxis.categories.length).fill(0);
    let totalNet = Array(this.chartOptions.xaxis.categories.length).fill(0);
    let totalRevenue = Array(this.chartOptions.xaxis.categories.length).fill(0);

    let monthlyAnnualSum = 0
    let totalRevenueSum = 0
    let totalNetSum = 0
    let totalCashSum = 0

    this.chartOptions.xaxis.categories.forEach((item, index) => {

      cashBalance[index] = Math.round((this.dataSum.capital[index] + this.dataSum.revenue[index]) - this.dataSum.expenses[index]);

      totalRevenueSum += this.dataSum.revenue[index]

      if (index != 0) {
        cashBalance[index] += cashBalance[index - 1]
      }

      totalCashSum += cashBalance[index]

      let t = Math.round(this.dataSum.revenue[index] - this.dataSum.expenses[index]);
      monthlyAnnualSum += t;

      monthlyAnnual[index] = t

      if (index == 0) {
        totalNet[index] = monthlyAnnual[index]
      } else {
        totalNet[index] = monthlyAnnual[index] + totalNet[index - 1]
      }

      totalNetSum += totalNet[index]

      totalRevenue[index] = Math.round(this.dataSum.revenue[index] - this.dataSum.capital[index] - this.dataSum.expenses[index])

      if (index != 0) {
        totalRevenue[index] += totalRevenue[index - 1]
      }

    })

    if (monthlyAnnualSum > 0
    ) {
      this.anualFlag = 1
    } else {
      this.anualFlag = 0
    }

    if (totalNetSum > 0) {
      this.totalFlag = 1
    } else {
      this.totalFlag = 0
    }

    if (totalCashSum > 0) {
      this.cashFlag = 1
    } else {
      this.cashFlag = 0
    }

    this.profit_margin = Math.round((monthlyAnnualSum / totalRevenueSum * 100))

    this.series = [
      {
        name: this.$t('message.budget_cash_balance'),
        type: 'column',
        data: cashBalance
      }
      ,
      {
        name: this.$t('message.budget_profit_loss'),
        type: 'column',
        color: '#ffbf00',
        data: monthlyAnnual
      },
      {
        name: this.$t('message.budget_total_profit_loss'),
        type: 'line',
        color: '#00ad2e',
        data: totalNet
      },
      {
        name: this.$t('message.budget_net_result'),
        type: 'line',
        color: '#e20909',
        data: totalRevenue
      }
    ]

    let beLabel = this.original_labels[this.findFirstPositiveIndex(totalRevenue)]

    this.break_even = beLabel == null ? this.$t('message.never') : this.moment(beLabel).locale(this.locale).format('MMM, YY');
    // this.chartOptions.annotations.xaxis[0].x = this.break_even


    if (beLabel != null) {
      this.chartOptions.annotations.xaxis[0].x = this.break_even
      this.apexChartKey = Math.random()
    }

  },
  methods: {

    findFirstPositiveIndex(array) {
      for (let i = 0; i < array.length; i++) {
        if (array[i] > 0) {
          return i;
        }
      }
      return null;
    },

    rebuildData(request, labelsLength) {

      let formattedRecords = []
      let rate = request.result[0].name == 'Expenses' ? this.budget['burn_rate'] : this.budget['earn_rate'];

      let records = request.result[0].records

      records.forEach((record) => {

        let newRecord = {
          name: record.name,
          values: Array(labelsLength).fill(0)
        }

        let type = record.type


        if (type == 'One-time') {

          let label = this.moment(record.start).format('YYYY-MM');
          let index = this.original_labels.indexOf(label)

          if (index != -1) {
            newRecord.values[index] = +parseFloat(record.amount).toFixed(2)
          }

        } else {

          let start = this.moment(record.start).format('YYYY-MM');
          let end = this.moment(record.end).format('YYYY-MM');

          let startIndex = this.original_labels.indexOf(start)
          let endIndex = this.original_labels.indexOf(end)

          //Check earn or burn rate
          let recordsBetweenIndexes = endIndex - startIndex

          if (recordsBetweenIndexes == 0) {
            newRecord.values[startIndex] = +parseFloat(record.amount).toFixed(2)
          } else {

            for (let i = 0; i <= recordsBetweenIndexes; i++) {

              let amount = 0
              if (i == 0 || this.budget[rate] == 0) {
                amount = +parseFloat(record.amount).toFixed(2)
              } else {
                amount = parseFloat(newRecord.values[startIndex + i - 1]) + ((parseFloat(newRecord.values[startIndex + i - 1]) * rate) / 100)
              }

              newRecord.values[startIndex + i] = +amount.toFixed(2)
            }
          }
        }

        formattedRecords.push(newRecord)

      })

      let formattedObject = {}

      formattedRecords.forEach((item) => {

        if (formattedObject[item.name]) {

          for (let i = 0; i < item.values.length; i++) {
            formattedObject[item.name][i] += item.values[i]
          }

        } else {
          formattedObject[item.name] = item.values
        }
      })

      return formattedObject
    },

    setArrays(record, value, length) {

      if (record.chart.data.length == undefined) {
        Object.entries(record.chart.data).map(item => {

          if (!this.dataSum[value].length) {
            this.dataSum[value] = Array(length).fill(0);
          }


          item[1].forEach((record, index) => {
            this.dataSum[value][index] += record
          })
        })
      }
    }
    ,

    async loadSection(catId) {
      this.total_expenses = 0
      return await this.$store.dispatch('budget/loadSection', {id: catId, token: this.token})
    },

    buildMonthsPeriod() {

      let dateStart = this.moment(this.budget.start)
      let dateEnd = this.moment(this.budget.end)
      let timeValues = [];

      while (dateEnd > dateStart || dateStart.format('M') === dateEnd.format('M')) {
        timeValues.push(dateStart.format('YYYY-MM'));
        dateStart.add(1, 'month');
      }

      return timeValues

    }
  }
  ,
  computed: {
    performance() {
      return this.anualFlag + this.totalFlag + this.cashFlag
    }
    ,
    isLoading() {
      return this.$store.getters['shared/isLoading']
    }
    ,
    locale: function () {
      return this.$i18n.locale
    }
    ,
  }
}
;

</script>